module.exports = __webpack_public_path__ + "media/assets/images/tenant-portal-tips/warm-water4-ea0ddf8681f90dbd640b960d34e72473.jpg";